export function wouldCreateCycle(
  getParentId: (id: string) => string | null | undefined,
  folderId: string,
  targetParentId: string
): boolean {
  let currentId: string | null | undefined = targetParentId;
  const visited = new Set<string>();
  while (currentId) {
    if (currentId === folderId) return true;
    if (visited.has(currentId)) break;
    visited.add(currentId);
    currentId = getParentId(currentId);
  }
  return false;
}
